import { memo } from 'react';

function ReportsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M7.5 17.5h5m-5 0v-4.167m0 4.167H3.1a.6.6 0 01-.6-.6v-2.967a.6.6 0 01.6-.6h4.4m5 4.167v-10m0 10h4.4a.6.6 0 00.6-.6V3.1a.6.6 0 00-.6-.6h-3.8a.6.6 0 00-.6.6v4.4m0 0H8.1a.6.6 0 00-.6.6v5.233"
      ></path>
    </svg>
  );
}

export default memo(ReportsIcon);
